import { PiFunnel, PiMagnifyingGlassBold, PiTrashDuotone } from 'react-icons/pi';
import { Button, cn, Flex, Input } from '@v2/design-system';
import type { ShipmentListFilters as Filters } from './types';

const STAGES = [
    { value: '', label: 'Todos os estágios' },
    { value: 'pedido', label: 'Pedido' },
    { value: 'validacao', label: 'Validação' },
    { value: 'financeiro', label: 'Financeiro' },
    { value: 'producao', label: 'Produção' },
    { value: 'financeiro_2', label: 'Financeiro 2' },
    { value: 'embarque', label: 'Embarque' },
    { value: 'transito', label: 'Trânsito' },
    { value: 'desembaraco', label: 'Desembaraço' },
    { value: 'fiscal', label: 'Fiscal' },
    { value: 'entrega', label: 'Entrega' },
    { value: 'concluido', label: 'Concluído' },
];

const PROCESS_STATUSES = [
    { value: '', label: 'Todos os status' },
    { value: 'Aberto', label: 'Aberto' },
    { value: 'Finalizado', label: 'Finalizado' },
];

const RISK_LEVELS = [
    { value: '', label: 'Todo risco' },
    { value: 'Baixo', label: 'Baixo' },
    { value: 'Médio', label: 'Médio' },
    { value: 'Alto', label: 'Alto' },
];

type Props = {
    filters: Filters;
    showExtra: boolean;
    onChange: (patch: Partial<Filters>) => void;
    onToggleExtra: () => void;
    onClear: () => void;
};

const selectClass = 'ds-native-select ds-native-input';

export default function ShipmentListFilters({ filters, showExtra, onChange, onToggleExtra, onClear }: Props) {
    const hasFilters =
        filters.search ||
        filters.process_status ||
        filters.stage ||
        filters.delay_risk_level ||
        filters.order_date_from ||
        filters.order_date_to;

    return (
        <Flex align="center" justify="between" className="mb-4 flex-wrap gap-3">
            <Flex align="center" gap="3" className="min-w-0 flex-1 flex-wrap">
                <Input
                    type="search"
                    placeholder="Buscar PO, cliente, invoice…"
                    value={filters.search}
                    onChange={(e) => onChange({ search: e.target.value, page: 1 })}
                    className="w-full max-w-xs"
                    inputClassName="h-9"
                    clearable
                    prefix={<PiMagnifyingGlassBold className="size-4" />}
                />

                {showExtra && (
                    <>
                        <input
                            type="date"
                            title="Data pedido (de)"
                            value={filters.order_date_from}
                            onChange={(e) => onChange({ order_date_from: e.target.value, page: 1 })}
                            className={selectClass}
                        />
                        <input
                            type="date"
                            title="Data pedido (até)"
                            value={filters.order_date_to}
                            onChange={(e) => onChange({ order_date_to: e.target.value, page: 1 })}
                            className={selectClass}
                        />
                        <select
                            value={filters.process_status}
                            onChange={(e) => onChange({ process_status: e.target.value, page: 1 })}
                            className={selectClass}
                        >
                            {PROCESS_STATUSES.map((o) => (
                                <option key={o.value || 'all'} value={o.value}>
                                    {o.label}
                                </option>
                            ))}
                        </select>
                        <select
                            value={filters.stage}
                            onChange={(e) => onChange({ stage: e.target.value, page: 1 })}
                            className={selectClass}
                        >
                            {STAGES.map((o) => (
                                <option key={o.value || 'all'} value={o.value}>
                                    {o.label}
                                </option>
                            ))}
                        </select>
                        <select
                            value={filters.delay_risk_level}
                            onChange={(e) => onChange({ delay_risk_level: e.target.value, page: 1 })}
                            className={selectClass}
                        >
                            {RISK_LEVELS.map((o) => (
                                <option key={o.value || 'all'} value={o.value}>
                                    {o.label}
                                </option>
                            ))}
                        </select>
                        {hasFilters && (
                            <Button size="sm" variant="flat" onClick={onClear} className="h-9 bg-gray-200/70">
                                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" />
                                Limpar
                            </Button>
                        )}
                    </>
                )}
            </Flex>

            <Button
                variant="outline"
                onClick={onToggleExtra}
                className={cn('h-9 pe-3 ps-2.5', showExtra && 'border-dashed border-gray-700')}
            >
                <PiFunnel className="me-1.5 h-[18px] w-[18px]" strokeWidth={1.7} />
                {showExtra ? 'Ocultar filtros' : 'Filtros'}
            </Button>
        </Flex>
    );
}
